import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { CrossSellInput } from "src/common/api/apollo/additional/types/types";

export interface CrossSellState {
  data: CrossSellInput & { newSoSource?: string } | null;
}

const initialState: CrossSellState = {
  data: null,
};

export const crossSellSlice = createSlice({
  name: 'crossSell',
  initialState,
  reducers: {
    setCrossSell: (state: CrossSellState, action: PayloadAction<CrossSellInput & { newSoSource?: string } | null>) => {
      state.data = action.payload;
    },
    clearCrossSell: (state: CrossSellState) => {
      state.data = null;
    },
  },
});

export const { setCrossSell, clearCrossSell } = crossSellSlice.actions;

export default crossSellSlice.reducer;
